export default class Map_DynamicElementLine {
  geom;

  constructor(geom) {
    this.geom = geom;
  }

  getWKT() {
    let wkt = "";
    wkt = "LINESTRING (";
    this.geom.controlspoints.forEach((controlspoint) => {
      wkt +=
        controlspoint.longitude.toFixed(8) +
        " " +
        controlspoint.latitude.toFixed(8) +
        ",";
    });
    wkt = wkt.substring(0, wkt.length - 1);
    wkt += ")";
    return wkt;
  }

  getLength() {
    let length = 0;
    /*let poly = undefined;
    if (this.geom.controlspoints.length > 1) {
      poly = this.geom.polygon.getTurfLine();
      length = turf.length(poly, { units: "kilometers" }) * 1000;
    }*/
    length = this.geom.polygon.getLength();
    return length;
  }

  getEntityLine() {
    let entity = {
      position: new Cesium.CallbackProperty(() => {
        return this.geom.polygon.getCentroid();
      }, false),
      polyline: {
        positions: new Cesium.CallbackProperty(() => {
          return this.geom.getGeomHeightWGS();
        }, false),
        material: this.geom.material.getPolylineMaterial(),
        width: 3,
        clampToGround: true,
        show: new Cesium.CallbackProperty(() => {
          return this.geom.getVisibility();
        }, false),
        classificationType: Cesium.ClassificationType.BOTH,
      },
      label: {
        text: new Cesium.CallbackProperty(() => {
          return this.geom.getName();
        }),
        fillColor: Cesium.Color.WHITE,
        showBackground: true,
        backgroundColor: Cesium.Color.BLACK.withAlpha(0.7),
        backgroundPadding: new Cesium.Cartesian2(17, 15),
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        style: Cesium.LabelStyle.FILL,
        show: new Cesium.CallbackProperty(() => {
          return (
            this.geom.events.isPicked() &&
            this.geom.events.isControlPointClickLeft() == false &&
            this.geom.getName() !== "" &&
            this.geom.events.isInsert() == false &&
            this.geom.isTypeVisible(this.geom.getType())
          );
        }, false),
        scale: 0.4,
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        pixelOffset: new Cesium.Cartesian2(
          0,
          -this.geom.material.getSize() - 5
        ),
      },
    };
    entity.dynamic = this.geom;
    entity.show = true;
    return entity;
  }
}
